import * as React from 'react';
import ErrorBoundary from 'app/components/ErrorBoundary';
import { useState } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { Logger } from 'utils/logger';
import { trackException } from 'app-insights/appInsightsTracking';

export const AppErrorBoundaryWrapper: React.FC = () => {
  const [error, setError] = useState(0);
  const routeError = useRouteError();

  React.useEffect(() => {
    if (routeError && routeError instanceof Error) {
      trackException({ exception: routeError });
    }
    if (routeError instanceof Error || isRouteErrorResponse(routeError)) {
      Logger.error("Unhandled route error:", routeError);
    }
  }, [routeError]);

  const returnToHomeClicked = () => {
    setError(prevState => prevState + 1);
  };

  return (
    <div key={error} data-testid="ttm-insights-wrapper">
      <ErrorBoundary onReturnToHomeClicked={returnToHomeClicked} />
    </div>
  );
};
